var _defs, _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.53 25.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Detail Design") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 5.93,
    cy: 20.02,
    r: 5.93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 13.78,
    cy: 5.93,
    r: 5.93
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-783.61,99.91a5.93,5.93,0,0,0-5.93,5.93,5.93,5.93,0,0,0,5.93,5.93,5.93,5.93,0,0,0,5.93-5.93A5.93,5.93,0,0,0-783.61,99.91Zm0,9a3.06,3.06,0,0,1-3.06-3.06,3.06,3.06,0,0,1,3.06-3.06,3.06,3.06,0,0,1,3.06,3.06A3.06,3.06,0,0,1-783.61,108.9Z",
    transform: "translate(805.2 -85.82)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailDesign);
export default __webpack_public_path__ + "static/media/Detail Design.a6a41276.svg";
export { ForwardRef as ReactComponent };